import isEmpty from 'lodash/isEmpty';
import type { ProductData, ProductInfo, ProductInfoComboItem, ProductInfoCustomization } from '@/apis/product/types';
import { checkSingleComboProductIsDefault } from '../utils';

export const getCustomizationItemsTotalPrice = (items?: ProductInfoCustomization['items']) => {
  let _price = 0;
  if (items && !isEmpty(items)) {
    items.forEach((i) => {
      if (i.values) {
        const _v = i.values.find((v) => v.checked === 1);
        if (_v?.price && _v.quantity) {
          _price += _v.price * _v.quantity;
        }
      }
    });
  }
  return _price;
};

export const findCurProduct = (data?: ProductData['product'], matchedSpecsCode?: string): ProductInfo | undefined => {
  const _products = data?.products;
  if (_products && !isEmpty(_products)) {
    if (matchedSpecsCode) {
      const _item = _products.find((p) => p.matchedSpecsCode === matchedSpecsCode);
      if (_item) return _item;
    }
    return _products[0];
  }

  return data;
};

/**
 * for DynamicCombo
 * @param item
 */
export const isDCSingleCombo = (item?: ProductInfoComboItem) => {
  if (item) {
    if (
      item.maxQuantity === item.minQuantity &&
      item.maxQuantity === 1 &&
      item.comboProducts &&
      item.comboProducts.length > 1
    ) {
      return true;
    }
  }
  return false;
};

const classifictNameDict = {
  '1': '主食',
  '2': '小食',
  '3': '饮料',
  '4': '玩具',
  '5': '配料',
};

/**
 * for product-type 2
 */
export const checkSingleCombo = (combos?: ProductInfoComboItem[]): { name: string } | undefined => {
  let rtn = undefined;
  if (combos && Array.isArray(combos)) {
    for (let i = 0; i < combos.length; i++) {
      const combo = combos[i];
      if (combo && combo.isChoices === 1) {
        const { comboProducts, classification } = combo;
        const _selected = comboProducts?.find((p) => checkSingleComboProductIsDefault(p));
        if (!_selected) {
          const _name = combo.name || classifictNameDict[String(classification) as keyof typeof classifictNameDict];
          rtn = {
            name: _name,
          };
          break;
        }
      }
    }
  }
  return rtn;
};

export const checkDCComboCount = (combos?: ProductInfoComboItem[]): { diff: number; name: string } | undefined => {
  let rtn = undefined;
  if (combos && Array.isArray(combos)) {
    for (let i = 0; i < combos.length; i++) {
      const combo = combos[i];
      if (combo && combo.isIncludeRound !== 1 && combo.minQuantity && combo.minQuantity >= 1) {
        if (isDCSingleCombo(combo)) {
          const { comboProducts, classification } = combo;
          const _selected = comboProducts?.find((p) => checkSingleComboProductIsDefault(p));
          if (!_selected) {
            const name = classifictNameDict[String(classification) as keyof typeof classifictNameDict];
            rtn = {
              diff: 1,
              name,
            };
            break;
          }
        } else {
          const { comboProducts, classification } = combo;
          const _total = comboProducts?.map((p) => p.quantity || 0).reduce((a, b) => a + b, 0);

          if (_total != null && _total < combo.minQuantity) {
            const diff = combo.minQuantity - _total;
            if (classification) {
              const name = classifictNameDict[String(classification) as keyof typeof classifictNameDict];
              rtn = {
                diff,
                name,
              };
              break;
            }
          }
        }
      }
    }
  }
  return rtn;
};

export const checkDCComboIsEmpty = (combos?: ProductInfoComboItem[]): boolean => {
  if (combos && Array.isArray(combos)) {
    let _total = 0;
    for (let i = 0; i < combos.length; i++) {
      const combo = combos[i];
      // "已包含" / 单选模式 无需验证，肯定存在餐品
      if ((combo.isIncludeRound === 1 || isDCSingleCombo(combo)) && (combo.comboProducts?.length || 0) > 0) {
        return false;
      }

      const _cTotal = combo.comboProducts?.map((p) => p.quantity || 0).reduce((a, b) => a + b, 0) || 0;

      // 存在总数大于 0 项，则无需继续计算
      if (_cTotal > 0) {
        return false;
      }
      _total += _cTotal;
    }

    if (_total > 0) {
      return false;
    }
  }

  return true;
};
